import React from "react";

import domain from "../../assets/icons/domain.png";
import hosting from "../../assets/icons/hosting.png";
import email from "../../assets/icons/email.png";
import sitemap from "../../assets/icons/sitemap.png";
import webpage from "../../assets/icons/webpage.png";
import responsive from "../../assets/icons/responsive.png";
import socialmedia from "../../assets/icons/socialmedia.png";
import browser from "../../assets/icons/browser.png";
import seo from "../../assets/icons/seo.png";

import { v4 as uuidv4 } from "uuid";

const Highlight = () => {
  const iconList = [
    { id: uuidv4(), iconName: `${domain}`, title: "Domain Name Registration" },
    { id: uuidv4(), iconName: `${hosting}`, title: "Website Hosting" },
    { id: uuidv4(), iconName: `${email}`, title: "Business Email Accounts" },
    {
      id: uuidv4(),
      iconName: `${sitemap}`,
      title: "Information Architecture: Planning the Sitemap",
    },
    {
      id: uuidv4(),
      iconName: `${webpage}`,
      title: "Unique Designs: Beautiful, elegantly and Handcrafted websites",
    },
    {
      id: uuidv4(),
      iconName: `${responsive}`,
      title: "Responsive Designs: Mobile, Tablet, Desktop Friendly",
    },
    {
      id: uuidv4(),
      iconName: `${socialmedia}`,
      title: "Facebook/Twitter/LinkedIn Integration",
    },
    {
      id: uuidv4(),
      iconName: `${browser}`,
      title: "Perfect on all major Browsers: IE, Firefox, Chrome, Safari",
    },
    {
      id: uuidv4(),
      iconName: `${seo}`,
      title: "On-Page Search Engine Optimization",
    },
  ];

  return (
    <div className="px-10 sm:px-20 mt-10">
      <p className="text-center font-notosans text-2xl sm:text-4xl font-bold sm:py-5 text-[#333e49]">
        Here's Highlight of what you'll Get with Your Business Website:
      </p>
      <div className="grid-cols-3 grid gap-8 mt-10">
        {iconList.map((item) => (
          <div
            className="flex flex-col items-center mx-1 sm:mx-10"
            key={item.id}
          >
            <img className="w-10 sm:w-12" src={item.iconName} />
            <p className="font-notosans text-[10px] sm:text-sm text-center mt-3">
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Highlight;
